export default class Select {
    constructor() {
        this.selector = 'select';
        this.init();
    }

    init() {
        var self = this,
            $elements = $( self.selector );

        $elements.selectric( {
            arrowButtonMarkup: '<b class="arrow"></b>',
            inheritOriginalWidth: true,
            onOpen: function() { 
                $( self.selector ).blur(); 
            }
        } );

        $elements.on( 'change', function() {
            $elements.selectric( 'refresh' );
        } );

        $( 'form' ).on( 'woocommerce_update_variation_values', function() {
            $elements.selectric( 'refresh' );
        } );
    }
}